import { writable, derived } from 'svelte/store';
const browser = typeof window !== 'undefined';
import { userSettings, updateSetting } from './userSettingsStore';

// Create a derived store that gets theme from user settings. Default is
// 'dark' to match legacy parity (legacy portal/src/stores/themeStore.js:7
// uses the same fallback). All three theme defaults — here, userSettings
// defaultSettings, and the inline script in index.html — are kept in sync.
export const theme = derived(userSettings, ($userSettings) => {
  const themeValue = $userSettings.theme || 'dark';

  return themeValue;
});

export function toggleTheme() {
  const currentTheme = get(theme);
  const newTheme = currentTheme === 'light' ? 'dark' : 'light';

  // Update the user settings store
  updateSetting('theme', newTheme);
}

// Subscribe to theme changes and update DOM + persist to localStorage.
// Persistence lets the bootstrap script in index.html restore the right
// theme before the bundle loads on the next page load (including after
// an auth error that wipes the runtime stores).
if (browser) {
  theme.subscribe(value => {
    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add(value);
    // Set color-scheme for Safari native form controls (macOS Tahoe fix)
    document.documentElement.style.colorScheme = value;
    try {
      localStorage.setItem('portal_theme', value);
    } catch (_) { /* localStorage unavailable */ }
    // Dispatch a custom event to notify components of theme change
    window.dispatchEvent(new CustomEvent('themeChanged', { detail: value }));
  });
}

// Helper function to get current value from store
function get(store) {
  let value;
  store.subscribe(v => value = v)();
  return value;
}